import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { AlbumDb } from '../redux/albumDbSlice';

const useAllAlbumDbs = (userId: string | undefined): [string[], AlbumDb[]] => {
  const albumDb = useSelector((state: RootState) => state.albumDb);
  const ruaDb = useSelector((state: RootState) => state.relationUserAlbumDb);
  const ruaIds = Object.keys(ruaDb.relationUserAlbums).filter(id => ruaDb.relationUserAlbums[id].userId === userId);
  ruaIds.sort((a, b) => {
    const ruaIdA = ruaDb.relationUserAlbums[a];
    const ruaIdB = ruaDb.relationUserAlbums[b];
    return ruaIdA.order - ruaIdB.order;
  })
  const ids = ruaIds.map(id => ruaDb.relationUserAlbums[id].albumId);
  const albums = ids.map(id => albumDb.albums[id]);

  return [ids, albums];
}

export default useAllAlbumDbs;
